module.exports = __webpack_public_path__ + "img/home.50193fa4.png";